import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import { gsap } from 'gsap'
import { TWEEN } from 'three/examples/jsm/libs/tween.module.min.js'
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js'
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass.js'
import { Sky } from 'three/examples/jsm/objects/Sky.js'
// import * as dat from 'lil-gui'

// import { MapControls } from 'three/examples/jsm/controls/OrbitControls.js';

let sky, sun, mixer, action, animation, screen, basePosition, mainBoard, point, points, locker, pillar
let sceneReady = false

var isMobile = false; //initiate as false

// device detection
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
    isMobile = true;
}

const customCursor = document.querySelector('.cursor')

if (isMobile) {
    customCursor.remove()
    points = [
        {
            position: new THREE.Vector3(2.26, 0.23, -0.79),
            element: document.querySelector('.point-0')
        },
        {
            position: new THREE.Vector3(-2.63, 0.6, 1.68),
            element: document.querySelector('.point-1')
        },
        {
            position: new THREE.Vector3(-2.4, 0.4, -0.98),
            element: document.querySelector('.point-2')
        },
        {
            position: new THREE.Vector3(-0.16, 0.4, 0.19),
            element: document.querySelector('.point-3')
        },
        {
            position: new THREE.Vector3(-0.15, 0.4, -1.42),
            element: document.querySelector('.point-4')
        }
    ]
} else {
    points = [
        {
            position: new THREE.Vector3(2.26, 0.23, -0.79),
            element: document.querySelector('.point-0')
        },
        {
            position: new THREE.Vector3(-2.63, 0.6, 1.38),
            element: document.querySelector('.point-1')
        },
        {
            position: new THREE.Vector3(-2.63, 0.6, -0.98),
            element: document.querySelector('.point-2')
        },
        {
            position: new THREE.Vector3(-0.16, 0.4, 0.19),
            element: document.querySelector('.point-3')
        },        {
            position: new THREE.Vector3(-0.83, 0.4, -1.76),
            element: document.querySelector('.point-4')
        }
    ]
}

const handleCursor = (e) => {
    const x = e.clientX
    const y =  e.clientY
    gsap.to(customCursor, {
        duration:0.001,
        left: `${x}px`,
        top: `${y}px`
    })
    // customCursor.style.cssText =`left: ${x}px; top: ${y}px;`
}

// const gui = new dat.GUI({
//     // closed: true,
//     width: 400
// })

if (isMobile) {
    basePosition = {
        x: 16,
        y: 16,
        z: 16
    }
} else {
    basePosition = {
        x: 4,
        y: 16,
        z: 4
    }
}

function initSky() {

    // Add Sky
    sky = new Sky();
    sky.scale.setScalar( 450000 );
    scene.add( sky );

    sun = new THREE.Vector3();

    /// GUI

    const effectController = {
        turbidity: 10,
        rayleigh: 3,
        mieCoefficient: 0.005,
        mieDirectionalG: 0.7,
        elevation: 2,
        azimuth: 180,
        exposure: renderer.toneMappingExposure
    };


        const uniforms = sky.material.uniforms;
        uniforms[ 'turbidity' ].value = effectController.turbidity;
        uniforms[ 'rayleigh' ].value = effectController.rayleigh;
        uniforms[ 'mieCoefficient' ].value = effectController.mieCoefficient;
        uniforms[ 'mieDirectionalG' ].value = effectController.mieDirectionalG;

        const phi = THREE.MathUtils.degToRad( 90 - effectController.elevation );
        const theta = THREE.MathUtils.degToRad( effectController.azimuth );

        sun.setFromSphericalCoords( 1, phi, theta );

        uniforms[ 'sunPosition' ].value.copy( sun );

        renderer.toneMappingExposure = effectController.exposure;
        // renderer.render()
}

/**
 * Loaders
 */
const loadingBarElement = document.querySelector('.progress .bar')
const loadingScreen = document.querySelector(".splash")
// const loadingScreen = document.getElementById( 'loading-screen' )
const loadingManager = new THREE.LoadingManager(
    // Loaded
    () =>
    {
        // Wait a little
        window.setTimeout(() =>
        {
            loadingScreen.classList.add('ready')
            loadingBarElement.style.transform = ''
            setTimeout(() => { loadingScreen.style.display = "none"; }, 2000)
            gsap.to(overlayMaterial.uniforms.uAlpha, { duration: 3, value: 0, delay: 1 })
            // Animate overlay
            
            // loadingScreen.classList.add( 'fade-out' )
            // loadingScreen.addEventListener( 'transitionend', onTransitionEnd )
            introAnimation() // call intro animation on start
            gsap.to('#header', { duration: 1, transform: "translateY(0)", delay: 5})
            gsap.to(customCursor, { duration: 1, display: "inline"})
        }, 500)
    },

    // On Progres
    (itemUrl, itemsLoaded, itemsTotal) =>
    {
        // Calculate the progress and update the loadingBarElement
        if (isMobile) {
            const progressRatio = (itemsLoaded / itemsTotal) * 150
            const border = 152 - progressRatio
            gsap.to(loadingBarElement, {
                borderRightWidth: `${border}px`,
                width: `${progressRatio}px`,
                duration: .4,
            })
        } else {
            const progressRatio = (itemsLoaded / itemsTotal) * 300
            const border = 302 - progressRatio
            gsap.to(loadingBarElement, {
                borderRightWidth: `${border}px`,
                width: `${progressRatio}px`,
                duration: .4,
            })
        }
    }
)

// Draco loader
const dracoLoader = new DRACOLoader(loadingManager)
dracoLoader.setDecoderPath('draco/')

// GLTF loader
const gltfLoader = new GLTFLoader(loadingManager)
gltfLoader.setDRACOLoader(dracoLoader)

// Texture loader
const textureLoader = new THREE.TextureLoader(loadingManager)

/**
 * Base
 */
// Canvas
// const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()
scene.background = new THREE.Color( 0xF2D06B )

/**
 * Overlay
 */
const overlayGeometry = new THREE.PlaneGeometry(2, 2, 1, 1)
const overlayMaterial = new THREE.ShaderMaterial({
    // wireframe: true,
    transparent: true,
    uniforms:
    {
        uAlpha: { value: 1 }
    },
    vertexShader: `
        void main()
        {
            gl_Position = vec4(position, 1.0);
        }
    `,
    fragmentShader: `
        uniform float uAlpha;

        void main()
        {
            gl_FragColor = vec4(1.0, 1.0, 1.0, uAlpha);
        }
    `
})
const overlay = new THREE.Mesh(overlayGeometry, overlayMaterial)
scene.add(overlay)

/**
 * Textures
 */
const bakedTexture = textureLoader.load('baked-screen.jpg')

bakedTexture.flipY = false
bakedTexture.encoding = THREE.sRGBEncoding

/**
 * Materials
 */
// Baked material
const bakedMaterial = new THREE.MeshBasicMaterial({ map: bakedTexture })

const video = document.getElementById('video');

//Create video texture:
const videoTexture = new THREE.VideoTexture(video);
videoTexture.flipY = false
videoTexture.needsUpdate = true
videoTexture.minFilter = THREE.LinearFilter;
videoTexture.magFilter = THREE.LinearFilter;
const videoMaterial =  new THREE.MeshBasicMaterial( {map: videoTexture, side: THREE.FrontSide, toneMapped: false} );

/**
 * Model
 */
gltfLoader.load(
    'vpd-screen.glb',
    (gltf) =>
    {
        const bakedMesh = gltf.scene.children.find(child => child.name === 'vpd')
        animation = gltf.scene.children.find(child => child.name === 'ant004')
        screen = gltf.scene.children.find(child => child.name === 'screen')
        locker = gltf.scene.children.find(child => child.name === 'locker')
        pillar = gltf.scene.children.find(child => child.name === 'pillar')
        mainBoard = gltf.scene.children.find(child => child.name === 'board')

        bakedMesh.material = bakedMaterial
        animation.material = bakedMaterial

        locker.material = bakedMaterial
        pillar.material = bakedMaterial
        mainBoard.material = bakedMaterial

        screen.material = videoMaterial

        gltf.scene.position.y = -.5
        scene.add(gltf.scene)

        mixer = new THREE.AnimationMixer( gltf.scene )
        const clip = gltf.animations[0]
        action = mixer.clipAction(clip)
        action.setLoop(THREE.LoopOnce)
        action.clampWhenFinished = true
    }
)   

/**
 * Raycaster
 */
const raycaster = new THREE.Raycaster()
let currentIntersect = null
const rayOrigin = new THREE.Vector3(- 3, 0, 0)
const rayDirection = new THREE.Vector3(10, 0, 0)
rayDirection.normalize()

/**
 * Mouse
 */
const mouse = new THREE.Vector2(100, 100)

if (isMobile) {
    window.addEventListener('touchstart', (event) =>
    {
        mouse.x = event.touches[0].clientX / sizes.width * 2 - 1
        mouse.y = - ( event.touches[0].clientY / sizes.height) * 2 + 1
        handleCursor(event)
    })
} else {
    window.addEventListener('mousemove', (event) =>
    {
        event.preventDefault()
        mouse.x = event.clientX / sizes.width * 2 - 1
        mouse.y = - (event.clientY / sizes.height) * 2 + 1
        handleCursor(event)
    })
}

let load = false
let sound, audioLoader

document.getElementById('music').addEventListener("click",function() {
        if (!load) {        
            load = true
            // create an AudioListener and add it to the camera
            const listener = new THREE.AudioListener();
            camera.add( listener );

            // create a global audio source
            sound = new THREE.Audio( listener );

            // load a sound and set it as the Audio object's buffer
            audioLoader = new THREE.AudioLoader();

            audioLoader.load( 'background.m4a', function( buffer ) {
                sound.setBuffer( buffer );
                sound.setLoop( true );
                sound.setVolume( 0.2 );
                sound.play()
            });
        } else if (load && !sound.isPlaying) {
            sound.play()
        } else if (load && sound.isPlaying) {
            sound.pause()
        }
    }
)

document.getElementById('aboutButton').addEventListener("click", function() {
    document.getElementById("about--container").classList.add("visible")
})

document.getElementById('closeButton').addEventListener("click", function() {
    document.getElementById("about--container").classList.remove("visible")
})

window.addEventListener('click', () =>
{
    if(currentIntersect)
    {
        switch(currentIntersect.object)
        {
            case animation:
                // console.log(currentIntersect)
                if ( action !== null ) {
                    // action.clampWhenFinished = true
                    action.stop();
                    action.play();
                }
                if(!isMobile) {
                    animateCamera({ x: -2.401844652969195, y: 0.36907969762686044, z: 0.9887296227981162 }, { x: -0.3945753289758924, y: 0.07892762346002047, z: -0.9117826685818984})
                } else {
                    animateCamera({ x: -3.0965968869356786, y: 0.36907969762686055, z: 1.0872591684851405 }, { x: -0.47929378912376785, y: 0.03659810037190536, z: -1.1577642366191043})
                }
                points[4].element.classList.add('visible')
                point = points[4]
                sceneReady = true
                break
            case screen:
                if(!isMobile) {
                    animateCamera({ x: 0.16840962239902515, y: 0.2795153248250622, z: -0.4504328764910358 }, { x: 2.19738563062961, y: -0.011814043166175025, z: -0.22332231562203544})
                } else {
                    animateCamera({ x: -0.7133789053633842, y: 0.7053616821184831, z: -0.4950886025135294 }, { x: 3.021145216199868, y: 0.12580401842992062, z: -0.6577714904167585})
                }
                video.play()
                points[0].element.classList.add('visible')
                point = points[0]
                sceneReady = true
                break
            case mainBoard:
                if(!isMobile) {
                    animateCamera({ x: 0.10546068035724687, y: 0.7163004688527339, z: 1.1881064981540315 }, { x: -2.9773350954055786, y: 0.624466939880008, z: 1.0120635015791315})
                } else {
                    animateCamera({ x: 4.10546068035724687, y: 0.3163004688527339, z: 3.7881064981540315 }, { x: -2.9773350954055786, y: 0.624466939880008, z: 1.0120635015791315})
                }
                points[1].element.classList.add('visible')
                point = points[1]
                sceneReady = true
                break
            case locker:
                // console.log(currentIntersect)
                if(!isMobile) {
                    animateCamera({ x: -0.8680030907802738, y: 0.8398990338564073, z: 2.297054410963702 }, { x: -2.1303645302002465, y: 0.32950680321031633, z: -1.108031153678894})
                } else {
                    animateCamera({ x: -0.8680030907802738, y: 0.8398990338564073, z: 2.297054410963702 }, { x: -2.1303645302002465, y: 0.32950680321031633, z: -1.108031153678894})
                }
                points[2].element.classList.add('visible')
                point = points[2]
                sceneReady = true
                break
            case pillar:
                // console.log(currentIntersect)
                if(!isMobile) {
                    animateCamera({ x: 1.9386951574307458, y: 0.3450352729187215, z: 3.3818738236868437 }, { x: 0.12744128881759553, y: 0.32085845483074205, z: 0.11976003646850586})
                } else {
                    animateCamera({ x: 1.9386951574307458, y: 0.3450352729187215, z: 3.3818738236868437 }, { x: 0.12744128881759553, y: 0.32085845483074205, z: 0.11976003646850586})
                }
                points[3].element.classList.add('visible')
                point = points[3]
                sceneReady = true
                break
        }
    }
})

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    // canvas: canvas,
    antialias: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.outputEncoding = THREE.sRGBEncoding
renderer.toneMapping = THREE.ACESFilmicToneMapping
renderer.toneMappingExposure = 1.015
document.body.appendChild( renderer.domElement )

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(30, sizes.width / sizes.height, 0.1, 1000)
camera.position.set(0, 0, 200)

scene.add(camera)

// Controls
// const controls = new MapControls(camera, renderer.domElement)
const controls = new OrbitControls(camera, renderer.domElement)
controls.enableDamping = true
controls.dampingFactor = 0.04
controls.target.set(0, 0, 0)
controls.enableRotate = true
controls.enablePan = false

// Locks on X axis
controls.minPolarAngle = Math.PI/3
controls.maxPolarAngle = Math.PI/2

// // Minimize roration on Y axis 
// controls.minAzimuthAngle = 0
// controls.maxAzimuthAngle = Math.PI/2

function introAnimation() {
    controls.enabled = false //disable orbit controls to animate the camera
    
    new TWEEN.Tween(camera.position.set(0, 0, 200)).to(basePosition
        // { // from camera position
        //     x: 4, //desired x position to go
        //     y: 16, //desired y position to go
        //     z: 4 //desired z position to go
        // }
    , 6000) // time take to animate
    .delay(1000).easing(TWEEN.Easing.Quartic.InOut).start() // define delay, easing
    .onComplete(function () { //on finish animation
        controls.enabled = true //enable orbit controls
        // setOrbitControlsLimits() //enable controls limits
        TWEEN.remove(this) // remove the animation from memory
        action.play()
        // gui.add(points[4].position, 'x').min(- 3).max(3).step(0.01).name('x')
        // gui.add(points[4].position, 'y').min(- 3).max(3).step(0.01).name('y')
        // gui.add(points[4].position, 'z').min(- 3).max(3).step(0.01).name('z')
    })
}

/**
 * Effect
 */
const composer = new EffectComposer( renderer );
const renderPass = new RenderPass( scene, camera )
composer.addPass( renderPass )

const params = {
    exposure: .01,
    bloomStrength: .06,
    bloomThreshold: 0,
    bloomRadius: 0
}

const bloomPass = new UnrealBloomPass( new THREE.Vector2( window.innerWidth, window.innerHeight ), 1.5, 0.4, 0.85 )
bloomPass.threshold = params.bloomThreshold
bloomPass.strength = params.bloomStrength
bloomPass.radius = params.bloomRadius

composer.addPass( bloomPass )

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{    
    TWEEN.update()

    // Update points only when the scene is ready
    if(sceneReady)
    {
        // Get 2D screen position
        const screenPosition = point.position.clone()
        screenPosition.project(camera)

        // Set the raycaster
        raycaster.setFromCamera(screenPosition, camera)
        const intersects = raycaster.intersectObjects(scene.children, true)

        // No intersect found
        if(intersects.length === 0)
        {
            // Show
            point.element.classList.add('visible')
        }

        // Intersect found
        else
        {
            // Get the distance of the intersection and the distance of the point
            const intersectionDistance = intersects[0].distance
            const pointDistance = point.position.distanceTo(camera.position)

            // Intersection is close than the point
            if(intersectionDistance < pointDistance)
            {
                // Hide
                point.element.classList.remove('visible')
            }
            // Intersection is further than the point
            else
            {
                // Show
                point.element.classList.add('visible')
            }
        }

        const translateX = screenPosition.x * sizes.width * 0.5
        const translateY = - screenPosition.y * sizes.height * 0.5
        point.element.style.transform = `translateX(${translateX}px) translateY(${translateY}px)`
    }

    if (mixer) {
        raycaster.setFromCamera(mouse, camera)
    
        const objectsToTest = [animation, screen, mainBoard, locker, pillar]
        const intersects = raycaster.intersectObjects(objectsToTest)
        
        if(intersects.length)
        {
            if(!currentIntersect)
            {
                customCursor.classList.add('collision')
            }
            currentIntersect = intersects[0]
        }
        else
        {
            if(currentIntersect)
            {
                customCursor.classList.remove('collision')
            }
            currentIntersect = null
        }
    }

    
    // Update controls
    controls.update()
    // console.log(camera.position)
    // console.log(camera.rotation)
    // console.log(controls.target)
    // console.log(controls.rotation)
    
    // Animate
    var delta = clock.getDelta();
    if ( mixer ) mixer.update( delta );

    // Render
    composer.render()
    // renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()
initSky()

function animateCamera(position, rotation){

    for(const point of points) {
        point.element.classList.remove('visible')
    }

    controls.enabled = false //disable orbit controls to animate the camera
    
    var positionStart = camera.position
    var positionEnd = position

    new TWEEN.Tween(positionStart).to(positionEnd, 1800).easing(TWEEN.Easing.Quadratic.InOut).start()
    .onComplete(function () {
        TWEEN.remove(this)
    })

    var rotationStart = controls.target
    var rotationEnd = rotation

    new TWEEN.Tween(rotationStart).to(rotationEnd, 1800).easing(TWEEN.Easing.Quadratic.InOut).start()
    .onComplete(function () {
        controls.enableZoom = false
        controls.enabled = true
        // camera.lookAt(target.position)
        // controls.minAzimuthAngle = -Math.PI / 1.5
        // controls.maxAzimuthAngle = -Math.PI /3
        TWEEN.remove(this)
        createBackButton()
    })
}

function resetCamera(){
    sceneReady = false
    controls.minAzimuthAngle = Infinity
    controls.maxAzimuthAngle = Infinity
    controls.enabled = false //disable orbit controls to animate the camera

    for(const point of points) {
        point.element.classList.remove('visible')
    }

    var positionStart = camera.position
    var positionEnd = basePosition

    new TWEEN.Tween(positionStart).to(positionEnd, 1800).easing(TWEEN.Easing.Quadratic.InOut).start()
    .onComplete(function () {
        TWEEN.remove(this)
    })

    var rotationStart = controls.target
    var rotationEnd = {
        x: 0,
        y: 0,
        z: 0
    }

    new TWEEN.Tween(rotationStart).to(rotationEnd, 1800).easing(TWEEN.Easing.Quadratic.InOut).start()
    .onComplete(function () {
        controls.enableZoom = true
        controls.enabled = true
        TWEEN.remove(this)
    })
}

function createBackButton() {

    let backCleanup = document.querySelectorAll(".backbutton");
    backCleanup.forEach( (each) => { each.remove(); } );

    let backButton = document.createElement("div");
    backButton.classList.add("backbutton");
    backButton.innerHTML = `⬅`;
    document.body.append(backButton);

    if (isMobile) {
        backButton.addEventListener("touchstart", (event) => {
            resetCamera()
            backButton.remove()
        });
    } else {
        backButton.addEventListener("click", (event) => {
            TWEEN.removeAll()
            resetCamera()
            backButton.remove()
        });
    }
}